import React from 'react';
import './App.css';
import CourseForm from './CourseForm'; // Import your form component

const App = () => {
  return (
    <div>


        <CourseForm />  {/* Main form handling course and modules */}

    </div>
  );
};

export default App;
